import { z } from "zod";

const PostFilePayloadSchema = z.object({
  caption_language: z.string().optional(),
  content_type: z.string(),
  file_name: z.string(),
});
export type PostFilePayload = z.infer<typeof PostFilePayloadSchema>;

export const PostFileResponseSchema = z.object({
  object_id: z.string(),
  object_key: z.string(),
  object_url: z.string(),
  upload_fields: z.record(z.string(), z.string()),
  upload_url: z.string(),
});

const UploadFileArgsSchema = z.object({
  file: z.instanceof(File),
  language: z.string().optional(),
  caption_file_object_id: z.string().optional(),
  invalidate: z.boolean().optional(),
});
export type UploadFileArgs = z.infer<typeof UploadFileArgsSchema>;
